import { render, staticRenderFns } from "./Posting Archive.vue?vue&type=template&id=2ecc193e&"
import script from "./Posting Archive.vue?vue&type=script&lang=js&"
export * from "./Posting Archive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports